import { apiClient } from './api';

export interface DashboardStats {
  totalCustomers: number;
  activeCustomers: number;
  pendingVerification: number;
  totalWallets: number;
  totalTransactions: number;
  totalCcgGroups: number;
}

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    try {
      const response = await apiClient.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch dashboard stats:', error);
      return {
        totalCustomers: 0,
        activeCustomers: 0,
        pendingVerification: 0,
        totalWallets: 0,
        totalTransactions: 0,
        totalCcgGroups: 0,
      };
    }
  },
};
